import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {PartDetailPage} from "../part-detail/part-detail";

/**
 * Generated class for the PartOverviewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-part-overview',
  templateUrl: 'part-overview.html',
})
export class PartOverviewPage {

  salesOrder: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams
  ) {
    this.salesOrder = this.navParams.get('salesOrder');
  }

  ionViewDidLoad() {
  }

  goToPartDetails(part: any) {
    this.navCtrl.push(PartDetailPage, {
      part: part,
      salesOrder: this.salesOrder
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/part-overview/part-overview.ts